import { useState } from "react";
import { Location } from "@components/ui/location_input.tsx";
import { SearchBar } from "@components/job_search/search_bar.tsx";
import { useJobSearch } from "@hooks/use_job_search";

type Props = {
  granularLocationSearchEnabled: boolean;
};

const SearchSection = ({ granularLocationSearchEnabled }: Props) => {
  const [location, setLocation] = useState<Location | null>(null);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const submitJobSearch = useJobSearch();

  const handleSearch = () => {
    setLoading(true);

    submitJobSearch(
      {
        query: query || undefined,
        location: location?.display_name,
        lat: location?.latitude,
        lon: location?.longitude,
        location_type: location?.location_type || undefined,
        country_short_name: location?.country_short_name || undefined,
        state_short_name: location?.state_short_name || undefined,
      },
      {
        onFinish: () => setLoading(false),
      },
    );
  };

  return (
    <div className="welcome-search-bar-wrapper">
      {
        <SearchBar
          query={query}
          onQueryChange={setQuery}
          location={location}
          onLocationChange={setLocation}
          onSearch={handleSearch}
          disabled={loading}
          granularLocationSearchEnabled={granularLocationSearchEnabled}
        />
      }
    </div>
  );
};

export default SearchSection;
